import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 1.4rem 0;
  border-bottom: 1px solid var(--border);

  :last-child {
    border-bottom: none;
  }
`;

const Description = styled.p`
  font-size: 1.4rem;
  font-weight: 600;
  color: var(--ink);
  margin-right: 1rem;
`;

const Amount = styled.p`
  margin-left: auto;
  font-weight: 700;
  color: var(--ink);
  font-variant-numeric: tabular-nums;
  align-self: flex-start;
`;

const DateText = styled.p`
  font-size: 1.25rem;
  color: var(--ink-faint);
  margin-top: 0.4rem;
`;

const IconContainer = styled.div`
  background-color: var(--surface-2);
  width: 4.6rem;
  min-width: 4.6rem;
  height: 4.6rem;
  border-radius: 50%;
  color: var(--ink-soft);
  margin-right: 1.5rem;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export { Container, Description, Amount, DateText, IconContainer };
